import { Box } from '@awning/components';
export const SearchBoxStep: React.FC<React.PropsWithChildren<{ step: number }>> = ({
  children,
}) => {
  return <Box sx={{ zIndex: '99999' }}>{children}</Box>;
};
